import { FC } from 'react';
import { OptionalTermsOfUse } from './OptionalTermsOfUse/OptionalTermsOfUse';
import { PageTemplate } from '@/components/uiParts/Template/PageTemplate/PageTemplate';
// import { termType } from '@/consts/terms';
// import { useTerm } from '@/hooks/api/term/useTerm';

interface OptionalTermsOfUsePageType {
  low?: string;
}

export const OptionalTermsOfUsePage: FC = (
  props: OptionalTermsOfUsePageType,
) => {
  const html = props.low; // オプション規約
  return (
    <PageTemplate
      pageName={'OptionalTermsOfUse'}
      title={'オプション規約'}
      showNavBack
    >
      <OptionalTermsOfUse html={html} />
    </PageTemplate>
  );
};
